import "reflect-metadata";

await import("./App");
